<template>
    <div class="pb-10">
        <v-row dense>
            <v-col cols="12" md="2" />
            <v-col cols="12" md="10">
                <v-row dense>
                    <v-col class="flex-grow-0">
                        <v-number-input
                            v-model="contract.duration"
                            control-variant="stacked"
                            :label="`${$t('duration')} (${$t('day', 2)})*`"
                            :min="1"
                            :step="1"
                            :rules="[requiredRule('duration'), onlyInteger('duration')]"
                            width="180px"
                            density="compact"
                            data-cy="duration"
                            variant="outlined"
                            @update:model-value="updateNumberInput"
                        />
                    </v-col>
                    <v-col cols="10" sm="4" md="3">
                        <ProgramSelect v-model="contract.programId" density="compact" />
                    </v-col>
                    <v-col cols="2">
                        <v-btn
                            size="small"
                            icon="mdi-plus"
                            variant="text"
                            data-cy="add-service"
                            @click="isShowModal = true"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="2">
                <span class="text-h6 text--secondary">
                    {{ $t('start_end_points') }}
                </span>
            </v-col>
            <v-col cols="12" md="8">
                <v-row dense class="px-1 pb-8">
                    <v-col cols="12" md="6">
                        <div class="text-subtitle-1 font-weight-medium">{{ $t('starting_location') }}</div>
                        <InfoLocationForm v-model="contract.departureLocations" />
                    </v-col>
                    <v-col cols="12" md="6">
                        <div class="text-subtitle-1 font-weight-medium">{{ $t('ending_location') }}</div>
                        <InfoLocationForm v-model="contract.destinationLocations" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" md="6">
                        <v-combobox
                            v-model="tags"
                            :label="$t('tags')"
                            chips
                            multiple
                            clearable
                            density="compact"
                            variant="outlined"
                            color="primary"
                            data-cy="tags"
                            @update:model-value="contract.tags = tags.join(',')"
                        >
                            <template v-slot:chip="{attrs, item}">
                                <v-chip v-bind="attrs" closable color="primary" @click:close="removeLabel(item.value)">
                                    <strong>{{ item.title }}</strong>
                                </v-chip>
                            </template>
                        </v-combobox>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="2">
                <span class="text-h6 text--secondary">
                    {{ $t('configuration') }}
                </span>
            </v-col>
            <v-col cols="12" md="8">
                <v-radio-group v-model="contract.priceConfiguration" density="compact" hide-details class="pb-2">
                    <v-radio :label="$t('dynamic_configuration')" value="DYNAMIC" data-cy="dynamic" />
                    <v-radio :label="$t('static_configuration')" value="STATIC" data-cy="static" />
                </v-radio-group>
            </v-col>
        </v-row>
        <InfoProgramForm v-model="isShowModal" @save="updateProduct()" />
    </div>
</template>

<script setup lang="ts">
    import InfoLocationForm from '~/components/products/information/InfoLocationForm.vue'
    import {onlyInteger, requiredRule} from '~/composables/rules'
    import InfoProgramForm from '~/components/products/information/InfoProgramForm.vue'
    import ProgramSelect from '~/components/account/snippets/ProgramSelect.vue'

    const tags = ref<string[]>([])
    const isShowModal = ref<boolean>(false)

    const contract = defineModel<any>()

    onMounted(async () => {
        if (contract.value.tags) tags.value = contract.value.tags.split(',')
        delete contract.value.programName
    })

    const removeLabel = item => {
        tags.value = tags.value.filter(label => item !== label)
    }

    const updateProduct = async (): Promise<void> => {
        await supplierStore.loadPrograms()
        isShowModal.value = false
    }

    const updateNumberInput = e => {
        if (isNaN(e)) contract.value.duration = null
    }
</script>
